import { memo } from 'react'
import {
  BaseEdge,
  getSmoothStepPath,
  type EdgeProps,
} from '@xyflow/react'
import { cn } from '@trafiflow/shared-ui'

interface PipelineEdgeData {
  isCompleted?: boolean
  isActive?: boolean
}

function PipelineEdgeComponent({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  markerEnd,
}: EdgeProps) {
  const edgeData = data as PipelineEdgeData | undefined
  const isCompleted = edgeData?.isCompleted ?? false
  const isActive = edgeData?.isActive ?? false

  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 8,
  })

  return (
    <>
      {/* Background edge */}
      <BaseEdge
        id={id}
        path={edgePath}
        className={cn(
          'transition-all duration-300',
          isCompleted && '[&>path]:!stroke-emerald-500/50 [&>path]:!stroke-[2px]',
          isActive && '[&>path]:!stroke-blue-500 [&>path]:!stroke-[2px]',
          !isCompleted && !isActive && '[&>path]:!stroke-tf-border [&>path]:!stroke-[1.5px]',
        )}
        markerEnd={markerEnd}
      />

      {/* Animated dot for active edges */}
      {isActive && (
        <circle r="4" fill="rgb(59, 130, 246)" className="animate-pulse">
          <animateMotion dur="1.5s" repeatCount="indefinite" path={edgePath} />
        </circle>
      )}
    </>
  )
}

export default memo(PipelineEdgeComponent)
